import React from "react"

const SectionTitle = ({ children }) => (
  <h2 className="text-4xl font-bold">{children}</h2>
)
export default SectionTitle
